import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

import PagePremission from '@/routes/Restrictions/PagePremission';
import { lazyRouteComponent } from '@/utils/lazyLoad';
import BounsInvoicePermission from '@/utils/premissions/BounsInvoicePermission.enum';

const ItemBounsPage = lazyRouteComponent(
  () => import('@/pages/ItemsContainer/ItemBouns'),
);
const BounsInvoiceListPage = lazyRouteComponent(
  () => import('@/pages/ItemsContainer/BounsInvoice'),
);
const CreateBounsInvoicePage = lazyRouteComponent(
  () => import('@/pages/ItemsContainer/BounsInvoice/CreateInvoice'),
);

const BounsRoutes: RouteObject[] = [
  {
    index: true,
    element: <Navigate to="invoices" replace />,
  },
  {
    path: 'invoices',
    element: (
      <PagePremission prem={BounsInvoicePermission.Prem_BounsInvoice_View}>
        <BounsInvoiceListPage />
      </PagePremission>
    ),
  },
  {
    path: 'invoices/create',
    element: (
      <PagePremission prem={BounsInvoicePermission.Prem_BounsInvoice_Create}>
        <CreateBounsInvoicePage />
      </PagePremission>
    ),
  },
  {
    path: 'policies',
    element: (
      <PagePremission prem={BounsInvoicePermission.Prem_BounsInvoice_Create}>
        <ItemBounsPage />
      </PagePremission>
    ),
  },
];

export default BounsRoutes;
